var map = {
	"./illustrations/M6-15012022.png": "e23e",
	"./illustrations/bbc-26072019.jpg": "95bb",
	"./illustrations/bfmtv-17012022.png": "68fb",
	"./illustrations/digg-22072019.png": "e522",
	"./illustrations/forbes-28072019.png": "2182",
	"./illustrations/konbini-17022022.jpg": "de5c",
	"./illustrations/lestream-09032022.jpg": "044f",
	"./illustrations/time-28082019.webp": "edeb",
	"./illustrations/wired-28072019.webp": "7ee3",
	"./logos/bbc.svg": "f688",
	"./logos/bfmtv.svg": "a3b2",
	"./logos/digg.svg": "7878",
	"./logos/forbes.svg": "2eea",
	"./logos/konbini-techno.svg": "77f9",
	"./logos/lestream.png": "a16f",
	"./logos/m6.svg": "110e",
	"./logos/time.svg": "2107",
	"./logos/wired.svg": "173b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9130";